import { lazy } from "react";
import { RoutesLink } from "@/utility/RouteLinks";
import type { IProtectedLoginRoute } from "../types";

const Login = lazy(() => import("@/pages/auth/Login"));
const Forgot = lazy(() => import("@/pages/auth/Forgot"));
const VerifyOtp = lazy(() => import("@/pages/auth/VerifyOtp"));
const ResetPassword = lazy(() => import("@/pages/auth/ResetPassword"));
export const SsoLogin = lazy(() => import("@/pages/auth/SsoLogin"));

export const protectedLoginRoutes: IProtectedLoginRoute[] = [
    {
        path: RoutesLink?.authRoutes?.login,
        route: <Login />,
    },
    {
        path: RoutesLink?.authRoutes?.forgot,
        route: <Forgot />,
    },
    {
        path: RoutesLink?.authRoutes?.verifyOtp,
        route: <VerifyOtp />,
    },
    {
        path: RoutesLink?.authRoutes?.resetPassword,
        route: <ResetPassword />,
    },
];
